import { makeSelectCurrentSnapshot } from 'pages/SnapshotManagement/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import type { ImmutableSnapshot, Snapshot } from './snapshotManagementTypes';

interface SelectorProps {
  snapshot: ImmutableSnapshot;
}

const selector = createStructuredSelector({
  snapshot: makeSelectCurrentSnapshot(),
});

export const useCurrentSnapshot = (): Snapshot | null => {
  const { snapshot } = useSelector<unknown, SelectorProps>(selector);
  return useMemo(() => snapshot?.toJS() ?? null, [snapshot]);
};
